import BackButton from "../img/icons/icon_blue_back.svg";
import React from "react";
import { useHistory } from "react-router-dom";

const TermsPage = () => {
  const history = useHistory();
  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <div
            onClick={() => history.goBack()}
            className="icon_left d-flex align-items-center"
          >
            <img src={BackButton} alt="img" className="img-fluid" />
            <span className="head_title">Terms and Conditions</span>
          </div>
        </div>
      </header>
      <div className="body_content">
        <div className="inner_body tnc">
          <div>
            {/*Section 1*/}
            <h3 className="subheadtitle">1. General</h3>
            <div className="summary_block">
              <p className="desc">
                We, at Mumbai Arthritis Clinic & Research centre, having its
                registered office at Shop 15-16, Mayuresh Srishti Complex,
                Bhandup, Rajiv Gandhi Nagar, Bhandup West, Mumbai, Maharashtra
                400078, India (“MACR”, “we,” “us”) provide services to all
                individuals accessing or using our app, IC4.health (“Platform”)
                for any reason (“you”, “yours”, “User”) subject to the notices,
                terms, and conditions set forth in these terms and conditions
                (“Terms and Conditions”, “Agreement”), read with the Privacy
                Policy.
              </p>
              <p className="desc">
                The IC4.health, a mobile application, is operated by MACR. MACR
                may assign, transfer, and subcontract its rights and/or
                obligations under these Terms and Conditions to any third party,
                as it may deem fit, and you shall continue to be bound by these
                Terms and Conditions in the event of such assignment, transfer
                or subcontracting.
              </p>
              <p className="desc">
                Any accessing or browsing of the Platform and using the Services
                (as defined in these Terms and Conditions) indicates your
                agreement to all the terms and conditions in this Agreement. If
                you disagree with any part of the Terms and Conditions, then you
                may discontinue access or use of the Platform.
              </p>
            </div>

            {/*Section 2*/}
            <h3 className="subheadtitle">2. Eligibility</h3>
            <div className="summary_block">
              <p className="desc">
                When you use the Platform, you represent that you meet the
                following primary eligibility criteria:
              </p>
              <ul
                className="list_bullet ms-3"
                style={{ listStyleType: "disc" }}
              >
                <li>
                  <span className="desc">
                    You are at least 18 years old or accessing the Platform
                    under the supervision of a parent or guardian, who in such a
                    case will be deemed as the recipient / end-user of the
                    Services (as defined in these Terms and Conditions) for the
                    purpose of these Terms and Conditions.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You have not been previously suspended or removed by MACR or
                    any other MACR group entity or disqualified for any other
                    reason, from availing the Services.
                  </span>
                </li>
              </ul>
            </div>

            {/*Section 3*/}
            <h3 className="subheadtitle">3. Our Services</h3>
            <div className="summary_block">
              <p className="desc">
                Through the Platform, we provide you with the following services
                ("Services"):
              </p>
              <h4 className="maintitle">
                a. Creating and maintaining user accounts:
              </h4>
              <p className="desc">
                Users need to register on the Platform in order to use the
                Platform or the Services provided through the Platform. In order
                to register, you have to provide certain personal details
                including but not limited to your name, phone number, email
                address, birth date, gender, etc.
              </p>
              <h4 className="maintitle">b. Scheduling an appointment:</h4>
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    You can book an appointment for a medical consultation with
                    a doctor, advanced nurse practitioner, phlebotomist,
                    physiotherapist, pharmacist, and mental health therapist
                    (“HSP”) listed on the Platform.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You will receive a confirmation of appointment for a medical
                    consultation with an HSP of your choice, on the Platform and
                    / or via SMS and / or email. We reserve the right to
                    reschedule or cancel an appointment without any prior
                    notice. The time provided for consultation to you is
                    indicative and actual consultation time may change depending
                    on the consulting HSP’s discretion.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Consultations can be booked, rescheduled or cancelled free
                    of cost up to twenty-four hours prior to the start of the
                    appointment. You are allowed to reschedule an Online Medical
                    Consultation up to a maximum of three times for free.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Your consulting HSP reserves the right to provide a free
                    review, post medical consultation.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You may book an appointment for seeking the diagnostic tests
                    and packages offered by a HSP on the Platform. You may book
                    diagnostic test(s) and package(s) on the Platform and visit
                    the concerned diagnostic centre / lab of the HSP or schedule
                    the sample pickup from home by the HSP.
                  </span>
                </li>
              </ol>
              <h4 className="maintitle">c. Holding medical consultations:</h4>
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    You can have an Online Medical Consultation via audio call
                    or video call on the Platform with the HSP selected by you.
                    Please ensure that you are equipped with proper video
                    conference equipment and internet connectivity as required
                    for the service you want to avail. In case of inadequate
                    video conference equipment, technical error or defective
                    internet connectivity, we reserve the right to reschedule or
                    cancel your appointment without any notice. You understand
                    and acknowledge that there will not be any physical
                    examination involved and the Online Medical Consultation
                    services shall be provided remotely in accordance with these
                    Terms and Conditions. The opinion delivered by the HSP shall
                    solely be based on the verbal communication between the
                    concerned HSP and the patient, and any test reports and
                    other information provided/uploaded by you on the Platform.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Online consultation services are provided at the express
                    consent by the User and the same shall not be construed as a
                    replacement for physical consultation and the Services are
                    meant for general consultation only. If after online
                    consultation, if it is recommended to undergo any diagnostic
                    tests or if You are issued with a Prescription, the same are
                    provided based on the information and preliminary
                    examination, hence the same shall not be treated as
                    accurate, final and conclusive. HSP reserves their rights to
                    modify the prescription or recommended diagnostic tests if
                    the User provides any additional information in future
                    consultation.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Your medical records may be viewed by the HSP on the
                    Platform in the course of medical consultations and will
                    remain accessible to you for a specific number of days after
                    a particular consultation concludes, as determined by the
                    HSP.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    The Services are not meant in any way for emergency and
                    life-threatening conditions. It is advised to take the
                    patient to the nearest hospital in such cases.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Receiving e-prescription from the HSP based on the medical
                    consultation.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Accessing your medical records on the Platform.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Any other service that is made available on the Platform
                    from time to time subject to the scope of services specified
                    under Section 4 below.
                  </span>
                </li>
              </ol>
            </div>

            {/*Section 4*/}
            <h3 className="subheadtitle">4. Your use of the Platform</h3>
            <div className="summary_block">
              <p className="desc">
                As an end-user and recipient of Services, when you use the
                Platform, you agree to the following conditions of use:
              </p>
              <h4 className="maintitle">a. Conditions of use:</h4>
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    You are solely responsible for the medical, health and
                    personal information you provide on the Platform, and you
                    are requested to use your discretion in providing such
                    information.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    The advice or the services provided by the HSP will depend
                    upon the information you provide on the Platform. You will
                    provide accurate and complete information everywhere on the
                    Platform, based on which you will receive the Services.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You will be solely responsible for all access to and use of
                    this site by anyone using the password and identification
                    originally assigned to you whether or not such access to and
                    use of this site is actually authorized by you, including
                    without limitation, all communications and transmissions and
                    all obligations (including, without limitation, financial
                    obligations) incurred through such access or use. You are
                    solely responsible for protecting the security and
                    confidentiality of the password and identification assigned
                    to you.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    The information provided by you may be used by us for the
                    purpose of Services including analysis, research, training
                    and disclosure (where required) to our affiliates, group
                    companies, agents and government authorities, etc., as
                    stated in our Privacy Policy. Please separately review and
                    consent to our Privacy Policy, accordingly.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    The information provided by you can be retained by us and
                    can be used without revealing your identity, as per our
                    Privacy Policy.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    We reserve the right to refuse service or terminate accounts
                    at our discretion, if we believe that you have violated or
                    are likely to violate applicable law or these Terms and
                    Conditions.
                  </span>
                </li>
              </ol>
              <h4 className="maintitle">b. Scope of Services:</h4>
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    The Services availed by you from a HSP via the Platform are
                    an arrangement between you and the HSP you select. The
                    Platform only facilitates connections between you and the
                    HSP and bears no responsibility for the outcome of any such
                    medical consultation or other Services obtained by you.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    MACR shall not be liable for deficiency or shortfall in
                    Services / misdiagnosis / faulty judgment / interpretation
                    error / perception error / adverse events / inefficacy of
                    prescribed treatment or advice or investigation reports /
                    validity of the advice or prescription or investigation
                    reports provided by the HSP / unavailability of the
                    recommended or prescribed treatment or medication under any
                    condition or circumstances. Users are advised to use their
                    discretion for following the advice obtained post medical
                    consultation with HSP via the Platform or post Services.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You will be solely responsible for all access to and use of
                    this site by anyone using the password and identification
                    originally assigned to you whether or not such access to and
                    use of this site is actually authorized by you, including
                    without limitation, all communications and transmissions and
                    all obligations (including, without limitation, financial
                    obligations) incurred through such access or use. You are
                    solely responsible for protecting the security and
                    confidentiality of the password and identification assigned
                    to you.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    MACR only facilitates the connections between you and the
                    HSP established through the Platform and does not in any way
                    facilitate, encourage, permit or require you to contact the
                    HSP outside the Platform. Any contact between you and the
                    HSP through the Platform, will be subject to these Terms and
                    Conditions.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    If you are redirected to, or visit, any other website or app
                    from the Platform, including for the purposes of browsing,
                    or when the placement and / or fulfilment of an order of any
                    product/service (or any other aspect related thereto) takes
                    you to a different website/platform, MACR will not be
                    responsible for products or services received or purchased
                    by you on such other website or platform, or any aspect of
                    your experience on such website or any representations and
                    details provided on such website/platform concerning
                    products/services being displayed or sold by such
                    website/platform.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You may view and access the content available on the
                    Platform solely for the purposes of availing the Services,
                    and only as per these Terms and Conditions. You shall not
                    modify any content on the Platform or reproduce, display,
                    publicly perform, distribute, or otherwise use such content
                    in any way for any public or commercial purpose or for
                    personal gain.
                  </span>
                </li>
              </ol>
              <h4 className="maintitle">c. Prohibitions:</h4>
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    You may not reproduce, distribute, display, sell, lease,
                    transmit, create derivative works from, translate, modify,
                    reverse-engineer, disassemble, decompile or otherwise
                    exploit the Platform or any portion of it unless expressly
                    permitted by MACR in writing.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You may not make any commercial use of any of the
                    information provided on the Platform.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You may not impersonate any person or entity, or falsely
                    state or otherwise misrepresent your identity, age or
                    affiliation with any person or entity.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You may not upload any content prohibited under applicable
                    law, and / or designated as “Prohibited Content” under
                    Section 5.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    You may not assign, transfer, or sub-contract any of your
                    rights or obligations under these Terms or any related order
                    for Products to any third party, unless agreed upon in
                    writing by MACR.
                  </span>
                </li>
              </ol>
            </div>

            {/*Section 5*/}
            <h4 className="maintitle">5. Prohibited Content</h4>
            <div className="summary_block">
              <p className="desc">
                You shall not upload to, distribute, or otherwise publish
                through the Platform, the following Prohibited Content, which
                includes any content, information, or other material that:
              </p>
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    belongs to another person and to which the User does not
                    have any right to.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    is grossly harmful, harassing, blasphemous, defamatory,
                    obscene, pornographic, pedophilic, libelous, invasive of
                    another's privacy, hateful, or racially, ethnically
                    objectionable, disparaging, relating or encouraging money
                    laundering or gambling, or otherwise unlawful in any manner
                    whatever;
                  </span>
                </li>
                <li>
                  <span className="desc">harm minors in any way;</span>
                </li>
                <li>
                  <span className="desc">
                    infringes any patent, trademark, copyright or other
                    proprietary rights;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    violates any law in India for the time being in force;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    deceives or misleads the addressee about the origin of such
                    messages or communicates any information which is grossly
                    offensive or menacing in nature;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    communicates any information which is grossly offensive or
                    menacing in nature;
                  </span>
                </li>
                <li>
                  <span className="desc">impersonates another person;</span>
                </li>
                <li>
                  <span className="desc">
                    contains software viruses or any other computer code, files
                    or programs designed to interrupt, destroy or limit the
                    functionality of any computer resource;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    threatens the unity, integrity, defence, security or
                    sovereignty of India, friendly relations with foreign
                    states, or public order or causes incitement to the
                    commission of any cognisable offence or prevents
                    investigation of any offence or is insulting any other
                    nation;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    is abusive or inappropriate to the HSP conducting your
                    medical consultation or any employees, consultants or
                    technicians of MACR or affiliate who you may interact with
                    for availing Services; and
                  </span>
                </li>
                <li>
                  <span className="desc">
                    is not relating to the medical consultation or relating to
                    any of the services you avail from us. You also understand
                    and acknowledge that if you fail to adhere to the above, we
                    have the right to remove such information and / or
                    immediately terminate your access to the Services and / or
                    to the Platform.
                  </span>
                </li>
              </ol>
            </div>

            {/*Section 6*/}
            <h3 className="subheadtitle">6. Indemnity</h3>
            <div className="summary_block">
              <p className="desc">
                You hereby agree to indemnify, defend, and hold MACR, MACR’s
                contractors, agents, representatives, Users and HSPs, and each
                of the foregoing entities’ respective contractors, agents,
                representatives, service providers and suppliers, and all of the
                foregoing entities’ respective officers, directors, owners,
                employees, agents, representatives, harmless from and against
                any and all losses, damages, liabilities and costs arising from:
              </p>
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    Your use of the Platform or Service
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Your breach of terms, conditions or provisions of this
                    Agreement, or violation of any law, rules or regulations by
                    the User, or due to such other actions, omissions or
                    commissions of the User that gave rise to the claim.,
                  </span>
                </li>
                <li>
                  <span className="desc">
                    any negligent or intentional wrongdoing on Your part,
                  </span>
                </li>
                <li>
                  <span className="desc">
                    misrepresentations or fraudulent feedback that has adversely
                    affected MACR or its Users,
                  </span>
                </li>
                <li>
                  <span className="desc">
                    User’s actions resulting from the User’s viewing of Content
                    on the Platform,
                  </span>
                </li>
                <li>
                  <span className="desc">
                    any legal or third party intellectual property right claim
                    that may arise from the User Content and
                  </span>
                </li>
                <li>
                  <span className="desc">
                    any such claim or liability arising out of unauthorized use
                    of Platform and content within the Platform.
                  </span>
                </li>
              </ol>
            </div>

            {/*Section 7*/}
            <h3 className="subheadtitle">7. Limitation of Liability</h3>
            <div className="summary_block">
              <p className="desc">
                To the fullest extent permitted by law, in no event will MACR or
                its contractors or agents (including HSPs) or any of their
                directors, officers, employees, agents or content or service
                providers (collectively, the “Protected Entities”) be liable for
                any direct, indirect, special, incidental, punitive, exemplary
                or consequential damages (including, without limitation, loss of
                business, revenue, profits, goodwill) arising from, or directly
                or indirectly related to, the use of, reliance on, or the
                inability to use or rely on, the Platform or the Services,
                materials and functions related thereto whether or not MACR has
                been warned of the possibility of such damages or could have
                reasonably foreseen such damages.
              </p>
              <p className="desc">
                Notwithstanding anything to the contrary in this Agreement, in
                no event shall the total aggregate liability of the Protected
                Entities to a User for all damages, losses, and causes of action
                (whether in contract or tort, including, but not limited to,
                negligence or otherwise) arising from the terms and conditions
                or a User’s use of the Platform exceed, in the aggregate, INR
                5000 or the amount of payment against Services that has been
                directly received by MACR from the User in the past three
                months, whichever is lower.
              </p>
              <p className="desc">
                This section shall survive the termination of this Agreement and
                the termination of your use of our Services or the Platform.
              </p>
            </div>

            {/*Section 8*/}
            <h3 className="subheadtitle">8. Data & Information Policy</h3>
            <div className="summary_block">
              <p className="desc">
                We respect your right to privacy in respect of any personal
                information provided to us for the purposes of availing our
                Services. To see how we collect and use your personal
                information, please see our Privacy Policy.
              </p>
            </div>

            {/*Section 9*/}
            <h3 className="subheadtitle">
              9. Intellectual property and ownership
            </h3>
            <div className="summary_block">
              <p className="desc">
                You recognize and agree that all copyright, registered
                trademarks and other intellectual property rights on all
                materials or contents provided as part of the Platform belong to
                us at all times or to those who grant us the license for their
                use.
              </p>
              <p className="desc">
                No use of these may be made without the prior written
                authorization of MACR.
              </p>
            </div>

            {/*Section 10*/}
            <h3 className="subheadtitle">10. Other conditions</h3>
            <div className="summary_block">
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    Please note that your payments are processed in accordance
                    with applicable law and you may refer to our Payment and
                    Refunds Policy for details.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    We have made every effort to display, as accurately as
                    possible, the information provided by the relevant third
                    parties including HSPs. However, we do not undertake any
                    liability in respect of such information and or with respect
                    to any other information in regard to which you are capable
                    of conducting your own due diligence to ascertain accuracy.
                  </span>
                </li>
              </ol>
            </div>

            {/*Section 11*/}
            <h3 className="subheadtitle">
              11. Third party links and resources
            </h3>
            <div className="summary_block">
              <p className="desc">
                Where the Platform contains links to other sites and resources
                provided by third parties (including where our social media
                sharing plug-ins include links to third party sites), these
                links are provided for your information only. We have no control
                over the contents of those websites/platforms or resources and
                accept no responsibility for them or for any loss or damage that
                may arise from your use of them.
              </p>
              <p className="desc">
                MACR is neither guaranteeing nor making any representation with
                respect to the goods or services made available or sold by such
                third party. MACR does not provide any warranty or
                recommendation in relation to the products and/or services made
                available to you by such third parties during your access or use
                of such third party website/platform including in relation to
                delivery, services, suitability, merchantability, reliability,
                availability or quality of the products and/or services.
              </p>
              <p className="desc">
                You shall not hold MACR, its group entities, affiliates, or
                their respective directors, officers, employees, agents and/or
                vendors responsible or liable for any actions, claims, demands,
                losses, damages, personal injury, costs, charges and expenses
                which you claim to have suffered, sustained or incurred, or
                claim to suffer, sustain or incur, directly or indirectly, on
                account of your use or access of third party website/platform.
              </p>
              <p className="desc">
                MACR is not a party to any contractual arrangements entered into
                between you and the third party website/platform. We are not the
                agent of the third party and such third party website/platform
                is governed exclusively by its respective policies over which
                MACR has no control.
              </p>
              <p className="desc">
                The use of such link to visit the third party website/platform
                implies full acceptance of these Terms and Conditions. MACR
                shall not be responsible or liable, directly or indirectly, for
                any damage or loss caused or alleged to be caused by or in
                connection with use of or reliance on any such content available
                on or through any such third party linked website, including
                without limitation any form of transmission received from any
                third party website or its server.
              </p>
            </div>

            {/*Section 12*/}
            <h3 className="subheadtitle">12. Amendments</h3>
            <div className="summary_block">
              <p className="desc">
                We may from time to time update or revise these Terms and
                Conditions. Every time you wish to use the Platform, please
                check the relevant Terms and Conditions and Privacy Policy to
                ensure you understand the terms that apply at that time.
              </p>
            </div>

            {/*Section 13*/}
            <h3 className="subheadtitle">13. Events Beyond Our Control</h3>
            <div className="summary_block">
              <p className="desc">
                We will not be liable for any non-compliance or delay in
                compliance with any of the obligations we assume under any
                contract when caused by events that are beyond our reasonable
                control (“Force Majeure”). Force Majeure shall include any act,
                event, failure to exercise, omission or accident that is beyond
                our reasonable control, including, among others, the following:
              </p>

              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    Strike, lockout or other forms of protest
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Civil unrest, revolt, invasion, terrorist attack or
                    terrorist threat, war (declared or not) or threat or
                    preparation for war.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Fire, explosion, storm, flood, earthquake, collapse,
                    epidemic or any other natural disaster.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Inability to use public or private transportation and
                    telecommunication systems.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Acts, decrees, legislation, regulations or restrictions of
                    any government or public authority including any judicial
                    determination.
                  </span>
                </li>
              </ol>

              <p className="desc">
                Our obligations deriving from any contracts should be considered
                suspended during the period in which Force Majeure remains in
                effect and we will be given an extension of the period in which
                to fulfil these obligations by an amount of time we shall
                communicate to you, not being less than the time that the
                situation of Force Majeure lasted.
              </p>
            </div>

            {/*Section 14*/}
            <h3 className="subheadtitle">14. Termination:</h3>
            <div className="summary_block">
              <ol className="ms-3" style={{ listStyleType: "lower-roman" }}>
                <li>
                  <span className="desc">
                    We may terminate this arrangement at any time, with or
                    without cause. If you wish to terminate this arrangement,
                    you may do so at any time by discontinuing your access or
                    use of this Platform.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    We reserve the right to refuse the use of Services
                    immediately in case your conduct is deemed by us to be in
                    contravention of applicable acts, laws, rules and
                    regulations or these Terms and Conditions or considered to
                    be unethical / immoral.
                  </span>
                </li>
                <li>
                  <span className="desc">
                    For change in law specifically, we reserve our rights to
                    suspend our obligations under any contract indefinitely, and
                    / or provide Services under revised Terms and Conditions.
                  </span>
                </li>
              </ol>
            </div>

            {/*Section 15*/}
            <h3 className="subheadtitle">
              15. Applicable legislation and jurisdiction
            </h3>
            <div className="summary_block">
              <p className="desc">
                The use of our Platform shall be governed by the laws applicable
                in India. Any dispute relating to the use of our Services shall
                be subject to the exclusive jurisdiction of the courts at
                Mumbai, India.
              </p>
            </div>

            {/*Section 16*/}
            <h3 className="subheadtitle">16. Contact Us</h3>
            <div className="summary_block">
              <p className="desc">
                If you have any query or grievances regarding the Services,
                Terms and Conditions and Privacy Policy, you may contact us at
                <a
                  href="mailto:standforas@ic4.health"
                  className="txt_color_orange"
                >
                  &nbsp;standforas@ic4.health
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsPage;
